/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-12 10:41:39
 * @LastEditTime: 2019-07-24 14:39:37
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  预约看仓企业信息接口
const appointmentUrl = '/website/storage/appointment'
//  邀请看仓企业信息接口
const invitationUrl = '/website/warehousing/invitation'

// 预约看仓企业信息接口
export function findOrderCompany(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + appointmentUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findOrderCompany'
      }, param))
    }
  })
}

// 预约看仓企业信息接口
export function findinviteCompany(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + invitationUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findinviteCompany'
      }, param))
    }
  })
}

